import React from "react"
import PropTypes from "prop-types"
import { Text } from "gatsby-interface"

import { StructuredLogLevel } from "@modules/graphql/types"
import {
  isInProgressStructuredLogs,
  formatLogLevel,
} from "@modules/build/shared/utils"

const propTypes = {
  logLevel: PropTypes.string,
  buildStatus: PropTypes.string,
}

function ZeroActivities({ logLevel = StructuredLogLevel.All, buildStatus }) {
  const formattedLogLevel = formatLogLevel(logLevel)
  let zeroActivitiesText = `Waiting for ${formattedLogLevel}...`
  if (!isInProgressStructuredLogs(buildStatus)) {
    zeroActivitiesText = `0 ${formattedLogLevel}`
  }

  return (
    <Text size="S" css={{ marginBottom: `0` }}>
      {zeroActivitiesText}
    </Text>
  )
}

ZeroActivities.propTypes = propTypes

export default ZeroActivities
